<template lang="pug">
  card-info(:title="title" :icon="icon")
    .card-body(slot="card-body")
      .columns.align-center.text-ellipsis
        .column.col-auto
          user-avatar.avatar-lg(:user="person")
        .column.text-ellipsis
          .text-ellipsis #[span Nome: #[span.text-bold {{ person.fullName }}]]
          .text-ellipsis #[span E-mail: #[span.text-bold {{ person.email }}]]
          .text-ellipsis #[span Telefone: #[span.text-bold {{ person.phoneNumber | phone }}]]
      .divider
      .text-bold Endereço
      div {{ person.address || '-' }}
    .card-footer(slot="card-footer")
      .columns.align-center
        .column
          .text-small Data de criação #[span.text-bold {{ person.createdAt | toDate('DD/MM/YYYY') }}]
        .column.col-auto
          slot(name="actions")
</template>

<script>
export default {
  props: {
    person: { type: Object, required: true },
    title: { type: String, default: 'Usuário' },
    icon: { type: String, default: 'fas fa-user' },
  },
}
</script>
